import { render, staticRenderFns } from "./OrderMailTargetStoreRegist.vue?vue&type=template&id=e0027828&scoped=true&"
import script from "./OrderMailTargetStoreRegist.vue?vue&type=script&lang=js&"
export * from "./OrderMailTargetStoreRegist.vue?vue&type=script&lang=js&"
import style0 from "./OrderMailTargetStoreRegist.vue?vue&type=style&index=0&id=e0027828&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0027828",
  null
  
)

export default component.exports